import { render, staticRenderFns } from "./firmware.vue?vue&type=template&id=5a49ae40&scoped=true"
import script from "./firmware.vue?vue&type=script&lang=js"
export * from "./firmware.vue?vue&type=script&lang=js"
import style0 from "./firmware.vue?vue&type=style&index=0&id=5a49ae40&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a49ae40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a49ae40')) {
      api.createRecord('5a49ae40', component.options)
    } else {
      api.reload('5a49ae40', component.options)
    }
    module.hot.accept("./firmware.vue?vue&type=template&id=5a49ae40&scoped=true", function () {
      api.rerender('5a49ae40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/firmware.vue"
export default component.exports